__turbopack_context__.v({
  "className": "gamja_flower_737843a4-module__wZIuDa__className",
});
